import type {
  BoardCertModalFormValues,
  DeaModalFormValues,
  EducationModalFormValues,
  LicenseModalFormValues,
  ProviderSettingsClinicalFormValues,
  ProviderSettingsProfileTabFormValues,
  SupplementalModalFormValues,
  TrainingModalFormValues,
} from '@/schemas/practitioner.schema';

export const EMPTY_PROVIDER_PROFILE_TAB: ProviderSettingsProfileTabFormValues = {
  preferredFirstName: '',
  preferredLastName: '',
  phone: '',
  street: '',
  city: '',
  state: '',
  zipCode: '',
  languages: [],
  bio: '',
  pronouns: '',
  genderIdentity: '',
  lgbtqiaIdentity: '',
  religion: [],
  raceEthnicity: [],
  ageGroups: [],
  specialties: [],
  modalities: [],
};

export const EMPTY_PROVIDER_CLINICAL: ProviderSettingsClinicalFormValues = {
  caqhId: '',
  caqhUsername: '',
  caqhPassword: '',
  lastCaqhAttestation: null,
};

export const EMPTY_LICENSE_MODAL: LicenseModalFormValues = {
  licenseName: '',
  licenseNumber: '',
  jurisdictionState: null,
  licenseStatus: '',
  issueDate: null,
  expirationDate: null,
  licenseType: null,
  isPrimary: false,
  superseded: false,
  documentFile: null,
};

export const EMPTY_CERT_MODAL: BoardCertModalFormValues = {
  boardCertificationName: '',
  certType: null,
  certificationNumber: '',
  certificationDate: null,
  certificateFile: null,
};

export const EMPTY_EDU_MODAL: EducationModalFormValues = {
  institution: '',
  degree: '',
  graduationYear: '',
};

export const EMPTY_DEA_MODAL: DeaModalFormValues = {
  deaNumberName: '',
  active: true,
  expirationDate: null,
  drugSchedules: '',
  businessActivity: '',
};

export const EMPTY_SUPP_MODAL: SupplementalModalFormValues = {
  trainingName: '',
  completedDate: null,
  trainingType: null,
};

export const EMPTY_TRAINING_MODAL: TrainingModalFormValues = {
  trainingType: '',
  completedDate: null,
};
